/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClassificationInformationTypes {
	SERVICES = 1,
	COMPANY_ROLES = 2,
	EMPLOYMENT_STATUSES = 3,
	EDUCATIONAL_CLASSIFICATIONS = 4,
	CUSTOMERGROUPS = 5,
	SERVICEDIRECTORIES = 6,
	ASSOCIATIONDIRECTORIES = 7,
}
